var NavigationService_1;
import { __decorate } from "tslib";
import { Injectable } from '@angular/core';
import { ConstructorName } from '../decorators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "./monitoring.service";
/**
 * Service for internal navigation between different components using queryParams
 * without changing routes
 *
 * @method registerNavigationListener - register a root component for listening to navigation requests, needs to implement OnNavigation
 * @method navigateTo - start a navigation request by passing an array of NavigationStep
 * @method getNextNavigation - gives the next navigation step of the current navigation, should be called in OnNavigation
 *
 * Used together with:
 * @enum NavigationComponent enum of components possible to navigate to
 * @interface NavigationStep one navigation step includes NavigationComponent and additional information
 * @interface OnNavigation should be implemented components which are part of the navigation or should listen to navigation requests
 */
let NavigationService = class NavigationService {
  static {
    NavigationService_1 = this;
  }
  router;
  activatedRoute;
  monitoringService;
  navigationListeners = [];
  currentNavigation = [];
  constructor(router, activatedRoute, monitoringService) {
    this.router = router;
    this.activatedRoute = activatedRoute;
    this.monitoringService = monitoringService;
    this.monitoringService.sendTrackEvent(Reflect.getMetadata('constructorName', NavigationService_1), 'constructor');
    // trigger onNavigation method for all navigationListeners
    activatedRoute?.queryParams?.subscribe(() => this.navigationListeners?.forEach(comp => comp.onNavigation()));
  }
  /**
   * When registering a component
   * OnNavigation Method will be triggered automatically on new navigation request
   * @param navComponent
   */
  registerNavigationListener(navComponent) {
    if (!this.navigationListeners.find(entry => entry === navComponent)) {
      this.navigationListeners.push(navComponent);
    }
  }
  /**
   * start a new navigation with specified configuration
   * @param navigateConfig
   */
  navigateTo(navigateConfig) {
    const queryParams = navigateConfig.map(navComp => navComp.id ? navComp.id.toString() : navComp.component);
    this.setQueryParams(queryParams);
  }
  /**
   * get the next navigation step of the current navigation
   */
  getNextNavigation() {
    if (this.activatedRoute?.snapshot?.queryParams) {
      const myNavigationArray = typeof this.activatedRoute.snapshot.queryParams['geauiNavigation'] === 'string' ? [this.activatedRoute.snapshot.queryParams['geauiNavigation']] : this.activatedRoute.snapshot.queryParams['geauiNavigation'];
      if (myNavigationArray !== this.currentNavigation) {
        this.currentNavigation = myNavigationArray;
      }
    }
    const navigationStep = this.currentNavigation?.shift();
    if (this.currentNavigation?.length < 1) {
      this.clearQueryParams();
    }
    return navigationStep;
  }
  // write navigation request to queryParams
  setQueryParams(navigationArray) {
    const currentRoute = this.activatedRoute;
    this.router.navigateByUrl('/', {
      skipLocationChange: true
    }).then(() => this.router.navigate([], {
      relativeTo: currentRoute,
      queryParams: {
        geauiNavigation: navigationArray
      },
      queryParamsHandling: 'merge'
    })).catch(error => {
      // eslint-disable-next-line no-console
      console.error(error);
    });
  }
  // clear queryParams
  clearQueryParams() {
    this.router.navigate(['/'], {
      relativeTo: this.activatedRoute,
      queryParams: {
        geauiNavigation: null
      },
      queryParamsHandling: 'merge',
      replaceUrl: true // force history update
    }).catch(error => {
      // eslint-disable-next-line no-console
      console.error(error);
    });
  }
  static ɵfac = function NavigationService_Factory(t) {
    return new (t || NavigationService)(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i1.ActivatedRoute), i0.ɵɵinject(i2.MonitoringService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: NavigationService,
    factory: NavigationService.ɵfac,
    providedIn: 'root'
  });
};
NavigationService = NavigationService_1 = __decorate([ConstructorName('NavigationService')], NavigationService);
export { NavigationService };
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavigationService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.Router
  }, {
    type: i1.ActivatedRoute
  }, {
    type: i2.MonitoringService
  }], null);
})();
